// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { FontIcon, ITheme, IStackStyles, Stack, Text, useTheme } from '@fluentui/react';

export const SoundEffectCard = (props: {
  title: string;
  isSelected: boolean;
  onSelect: () => void;
  disabled: boolean;
  active: boolean;
  icon: string;
  duration: number;
  currentDuration: number;
}): JSX.Element => {
  const theme = useTheme();

  return (
    <Stack>
      <Stack
        verticalAlign="center"
        horizontalAlign="center"
        tokens={{ childrenGap: '0rem' }}
        styles={soundEffectOptionStyles(theme, props.isSelected, props.disabled)}
        onClick={props.onSelect}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            props.onSelect();
          }
        }}
        tabIndex={props.disabled ? -1 : 0}
        aria-label={props.title}
        aria-disabled={props.disabled}
      >
        <Stack.Item>
          <FontIcon iconName={props.icon} />
        </Stack.Item>
        <Stack.Item>
          <Text variant="small">{props.title}</Text>
        </Stack.Item>
      </Stack>
    </Stack>
  );
};

const soundEffectOptionStyles = (theme: ITheme, isSelected: boolean, disabled: boolean): IStackStyles => ({
  root: {
    padding: '0.5rem',
    height: '4rem',
    width: '5.5rem',
    border: isSelected ? `3px solid ${theme.palette.themePrimary}` : `2px solid ${theme.palette.neutralQuaternaryAlt}`,
    borderRadius: '0.5rem',
    color: theme.palette.neutralSecondary,
    cursor: 'pointer',
    background: disabled ? theme.palette.neutralQuaternaryAlt : undefined,
    ':hover': {
      border: disabled ? `2px solid ${theme.palette.neutralQuaternaryAlt}` : `3px solid ${theme.palette.themePrimary}`,
      color: disabled ? theme.palette.neutralSecondary : theme.palette.neutralPrimary
    }
  }
});
